import React, { useEffect } from 'react';

const PolicyConfiguration = () => {
  React.useEffect(() => {
    // eslint-disable-next-line no-console
    console.warn('Placeholder: PolicyConfiguration is not implemented yet.');
  }, []);
  return (
    <>
  { /*PolicyConfiguration */} 
 </>
  );
};

export default PolicyConfiguration;
